import Vue from 'vue';
import toast from '@services/toasts';
import ProductPlanBillingCycle from '@/enums/productPlanBillingCycle';

const state = {
	productPlans: [],
	productPlans_loading: false,
    productPlans_loaded: false
};

const getters = {
	productPlans: state => {
		return state.productPlans;
	},
	productPlansLeastToMostExpensive: state => {
		return state.productPlans.sort((x,y) => {
			const xMonthly = x.pricingOptions.find(po => po.billingCycle === ProductPlanBillingCycle.Monthly)
			const yMonthly = y.pricingOptions.find(po => po.billingCycle === ProductPlanBillingCycle.Monthly)
			return xMonthly.unitAmount - yMonthly.unitAmount
		})
	},
	productPlanById: state => id => {
		return state.productPlans.find(x => x.id === id)
	},
	hasLoaded: state => {
		return state.productPlans_loaded;
	},
	productPlanCurrentlySubscribedTo: (state, getters, rootState, rootGetters) => {
		const subscription = rootGetters['loggedInSubscription']
		if (!subscription) return;
		return getters.productPlanById(subscription.productPlanId)
	}
};

const actions = {
	get({ commit, rootState }) {
		commit('GET_PENDING');
		return Vue.axios
			.get(`/api/${rootState.tenantId}/productPlans`)
			.then(response => {
				commit('GET_SUCCESS', response.data);
			})
			.catch(error => {
				commit('GET_FAILURE', error);
			});
	},
	async subscribe({ commit, dispatch, rootState } = {}, subscribeRequest) {
		try {
			const response = await Vue.axios.post(`/api/${rootState.tenantId}/productPlans/subscribe`, subscribeRequest)
			if (response.status === 200) {
				commit('SET_LOGGED_IN_EMPLOYEE_SUBSCRIPTION', response.data, { root: true });
				dispatch('initialiseAccessibleModules', null, { root: true })
				toast.success("Congratulations. You have successfully subscribed.")
			}
			return response;
		}
		catch (e) {
			console.error(e);
			const message = e.response.data.detail || "There was an error subscribing. If this issue persists please submit a support ticket";
			toast.error(message);
			return e.response;
		}
	},
	async cancelPlan({ commit, rootState, rootGetters } = {}) {
		try {
			const currentSubscription = rootGetters['loggedInSubscription'];
			if (!currentSubscription) return;

			const response = await Vue.axios.post(`/api/${rootState.tenantId}/productPlanSubscriptions/${currentSubscription.id}/cancel`);

			toast.success("Your cancellation has been processed")
			
			commit('SET_LOGGED_IN_EMPLOYEE_SUBSCRIPTION', response.data, { root: true });

			return response;
		}
		catch (e) {
			const message = e.response.data.detail || "There was an error deactivating your account. If this issue persists please submit a support ticket";
			toast.error(message);
			return e.response;
		}
	}
};

const mutations = {
	GET_PENDING(state) {
		state.productPlans_loading = true;
	},
	GET_SUCCESS(state, data) {
		state.productPlans_loading = false;
		state.productPlans = data;
        state.productPlans_loaded = true;
	},
	GET_FAILURE(state) {
		state.productPlans_loading = false;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
